import React from 'react';
import { TOCWrap, TOCTitle, TOCList, TOCItem } from '../styles/BlogStyles';

export default function BlogTOC({ items }) {
  if (!items || items.length === 0) return <TOCWrap />;

  const handleClick = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // atualiza URL sem reload
      window.history.replaceState(null, '', `#${id}`);
    }
  };

  return (
    <TOCWrap>
      <TOCTitle>Sumário</TOCTitle>
      <TOCList>
        {items.map((item) => (
          <TOCItem key={item.id}>
            <a href={`#${item.id}`} onClick={(e) => handleClick(e, item.id)}>
              {item.title}
            </a>
          </TOCItem>
        ))}
      </TOCList>
    </TOCWrap>
  );
}
